// extracted by mini-css-extract-plugin
module.exports = {"Title":"Container_Title__xA_4x","Container":"Container_Container__InggM"};